var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showModalVisualizarProcesso && _vm.idProcesso !== null
        ? _c("app-modal-visualizar-completo", {
            attrs: {
              idProcesso: _vm.idProcesso,
              protocolo: _vm.protocolo,
              numeroProcesso: _vm.numeroProcesso,
              tipo: _vm.tipoProcesso
            },
            on: {
              closeModal: function($event) {
                _vm.showModalVisualizarProcesso = false
              },
              solicitacaoEnviada: _vm.solicitacaoEnviada
            }
          })
        : _vm._e(),
      _vm.showModalSolicitarAcesso
        ? _c("app-modal-solicitar-acesso", {
            attrs: {
              idsProcessosSelecionados: _vm.processoEscolhido,
              idSolicitacao: _vm.idSolicitacao
            },
            on: {
              closeModal: function($event) {
                _vm.showModalSolicitarAcesso = false
              },
              limpar: _vm.limpar,
              solicitacaoEnviada: _vm.refreshInformacoes
            }
          })
        : _vm._e(),
      _c(
        "el-card",
        { staticClass: "card-container", attrs: { shadow: "hover" } },
        [
          _c("filtro", {
            attrs: {
              showOs: true,
              configuracaoFiltro: _vm.configuracaoFiltro,
              showfiltrosInformacoes: true,
              showPesquisaAvancada: false,
              placeholder: "Informe o nome do responsável ou numero do processo"
            },
            on: {
              pesquisar: _vm.pesquisarInformacoes,
              limpar: _vm.clearInformacoes
            }
          })
        ],
        1
      ),
      _c("app-listagem", {
        attrs: {
          "has-refresh-button": true,
          showButtonOrdemServico: false,
          showButtonAssinatura: false,
          "has-expansivel": false,
          "json-headers": _vm.colunas,
          "json-data": _vm.items,
          totalElements: _vm.totalElements,
          pagina: _vm.filtro.pagina
        },
        on: {
          updateListagem: _vm.refreshInformacoes,
          executar: _vm.executar,
          changePage: _vm.changePage,
          selected: false
        }
      }),
      _vm.modalMensagens
        ? _c("app-modal-notificar-interessado", {
            attrs: { idProcesso: _vm.idProcesso, isSolicitacao: true },
            on: { closeModal: _vm.closeModalNotificarInteressado }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11660a9e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11660a9e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/acompanharProcessos/CaixaSolicitacoes.vue
// module id = null
// module chunks = 